import { useCallback, useEffect, useState, useRef } from "react";
import { useParams } from 'react-router-dom'
import { Nav, Tab } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import Layout from '../../layout/default';
import CarePlanAttribute from "./CarePlanAttribute";
import PersonalDetails from "./PersonalDetails";
import ProductRates from "./ProductRates";
import Medication from "./Medication";
import Block from "../Block/Block"
import { Image, Icon, Schedule, Media, MediaGroup, MediaText } from "../../components"
import CustomerNotes from "./CustomerNotes";
import Spinner from 'react-bootstrap/Spinner';
import RecurringTasks from "./RecurringTasks";
import { Breadcrumb ,Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Emar from "./Emar";
import ClientSchedule from "./ClientSchedule";
import DocumentManagement from "../Storage/DocumentManagement";
import InvoiceList from "../Invoicing/InvoiceList";
import ProfileImageUploader from "../Storage/ProfileImageUploader";
import CustomerIncident from "./CustomerIncident";
import CustomerRiskAssessment from "./CustomerRiskAssessment";
import CustomerPreviousVisits from "./CustomerPreviousVisits";
import { useApiClient } from "../../ApiService/useApiClient";



const Client = () => {
    
let {id} = useParams();

const baseURL = "HMCareData/customerdetail/"+id;

const api =useApiClient()

const dataFetchedRef = useRef(false);
const[customer, setcustomer] = useState(null);  
const[error, setError] = useState(null); 
const[selectedTab, setSelectedTab] = useState("default-personal");
const[RecurringTabSelect, setRecurringTabSelect] = useState(false);
const[ScheduleTabSelect, setScheduleTabSelect] = useState(false);
const[InvoiceTabSelect, setInvoiceTabSelect] = useState(false);
const[IncidentTabSelect, setIncidentTabSelect] = useState(false);
const[RiskTabSelect, setRiskTabSelect] = useState(false);
const[PrevisitsSelect, setPrevisitsSelect] = useState(false);
const[ShowProfileImageUploadPopup, setShowProfileImageUploadPopup] = useState(false);
const[UserProfile, setUserProfile] = useState('/images/avatar/a.jpg')
const[CarePlanSelect, setcarePlanSelect] = useState('/images/avatar/a.jpg')
const [RefreshData, setRefreshData] = useState(false);

const ApiGetData = async (URL,setdataFunc, setErrorFunc,setUserProfile) => {   
    try{
    const response = await api.get(URL);
        setdataFunc(response.data);

        if(response.data && response.data.profileimage != ""){
        setUserProfile(response.data.profileimage)}
        //console.log(response.data);
    } catch(error) {
        setErrorFunc(error);      
    }
  };

const user = {
    theme : 'danger-soft',
    avatar : '/images/avatar/a.jpg',
    name : "",
    role : "",
  }


  useEffect(()=> {

    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    ApiGetData(baseURL,setcustomer,setError,setUserProfile);
       

},[RefreshData]);

//Tab select click
    const SelectedTabClick = (id)=>{
        setSelectedTab(id);    
        if (id == "default-recurring-tasks")
        {
            setRecurringTabSelect(true);    
        }
        if (id == "default-schedule")
        {
            setScheduleTabSelect(true);    
        }
        if (id == "default-invoicing")
        {
            setInvoiceTabSelect(true);    
        }
        if (id == "default-incident")
        {
            setIncidentTabSelect(true);    
        }
        if (id == "default-risk")
        {
            setRiskTabSelect(true);    
        }
        if (id == "default-previsits")
        {
            setPrevisitsSelect(true);    
        }
        if (id == "default-careplan")
        {
            setcarePlanSelect(true);    
        }


    }

    const showImageUploadPopup = ()=>{       
        setShowProfileImageUploadPopup(true);        
    }
   

    if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }

    if(!customer) return (
        <Layout title="Clients" content="container"><Spinner animation="border" variant="primary" /></Layout>
        );

   
const customerAddress = customer.companyAdd1 + ', ' +customer.companyAdd2 + ', ' +customer.companyAdd3 + ', ' +customer.postcode ;
const customerAge = customer.age;// "65 Years";
if(customer && customer.profileimage != ""){
    
    //alert(customer.profileimage);
}

  return (
    <Layout title="Clients" content="container">
    
    <Breadcrumb className="breadcrumb-arrow">
      <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>
      <Breadcrumb.Item><Link to={`/clients/`}>Clients</Link></Breadcrumb.Item>      
      <Breadcrumb.Item active>Client Details</Breadcrumb.Item>
    </Breadcrumb>

    <Block.Head>
            <Block.HeadBetween className="align-items-start">
                <Block.HeadContent>
                    <div className="d-flex flex-column flex-md-row align-items-md-center">
                        <Media size="huge" shape="circle" variant={user.theme && user.theme}>
                            {/* {user.avatar ? 
                                <Image src={user.avatar} staticImage thumbnail alt="user"/> :
                                <span className="fw-medium">{toInitials((customer.title??'') +' '+ customer.firstName +' '+ customer.lastName)}</span>
                            } */}
                            <Image src={UserProfile} staticImage thumbnail alt="user"/>

                        </Media>                        
                        <div className="mt-3 mt-md-0 ms-md-3">
                            <h3 className="title mb-1">{(customer.title??'') +' '+ customer.firstName +' '+ customer.lastName}</h3>
                            <span className="small">{customerAge} Years</span>
                            <ul className="nk-list-option pt-1">
                                <li><Icon name="map-pin"></Icon><span className="small">{customerAddress}</span></li>                                
                            </ul>
                        </div>
                    </div>
                    <div style={{}} onClick={showImageUploadPopup}><Icon name="edit-alt"></Icon><span style={{fontWeight:"bold", fontSize:"14px",cursor: "pointer"}}>Edit</span></div>
                </Block.HeadContent>
                {/* <Block.HeadContent>
                    <div className="d-flex gap g-3">
                        <div className="gap-col">
                            <div className="box-dotted py-2">
                                <div className="d-flex align-items-center">
                                    <div className="h4 mb-0">{user.followers}k</div>
                                    <span className="change up ms-1 small">
                                        <Icon name="arrow-down"></Icon>
                                    </span>
                                </div>
                                <div className="smaller">Followers</div>
                            </div>
                        </div>
                        <div className="gap-col">
                            <div className="box-dotted py-2">
                                <div className="d-flex align-items-center">
                                    <div className="h4 mb-0">{user.following}k</div>
                                    <span className="change up ms-1 small">
                                        <Icon name="arrow-up"></Icon>
                                    </span>
                                </div>
                                <div className="smaller">Following</div>
                            </div>
                        </div>
                    </div>
                </Block.HeadContent> */}
            </Block.HeadBetween>
        </Block.Head>

{/* {selectedTab} */}

    <Tab.Container id="client-details" defaultActiveKey="default-personal" onSelect={(id)=>{SelectedTabClick(id)}}>
    <Nav variant="tabs" className="nav-tabs-s1 mb-3">
        <Nav.Item>
            <Nav.Link eventKey="default-personal">Personal</Nav.Link>
        </Nav.Item>
        {/* <Nav.Item>
            <Nav.Link eventKey="default-contacts">Contacts</Nav.Link>
        </Nav.Item> */}
        {/* <Nav.Item>
            <Nav.Link eventKey="default-careplan">Care Plan</Nav.Link>
        </Nav.Item> */}
         <Nav.Item>
            <Nav.Link eventKey="default-medication">Medication</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-notes">Comms Log</Nav.Link>
        </Nav.Item>       
        <Nav.Item>
            <Nav.Link eventKey="default-rates">Services & Rates</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-docs">Documents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-recurring-tasks">Repeat Schedules</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-emar">eMar</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-schedule">Schedule</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-invoicing">Invoices</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-incident">Incidents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-risk">Risk Assessment</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="default-previsits">Recent Visit</Nav.Link>
        </Nav.Item>
        {/* <Nav.Item>
            <Nav.Link eventKey="default-careplan">Care Plan</Nav.Link>
        </Nav.Item> */}
    </Nav>
    <Tab.Content>
        <Tab.Pane eventKey="default-personal">
            <PersonalDetails datainfo={customer}/>    
        </Tab.Pane>
        {/* <Tab.Pane eventKey="default-contacts">
            <CustomerContacts data={customer} ShowClientAddress={true}/>
        </Tab.Pane> */}
        <Tab.Pane eventKey="default-medication">            
            <Medication data={customer} />
        </Tab.Pane>
        <Tab.Pane eventKey="default-careplan">
            {CarePlanSelect && <CarePlanAttribute AttributeData={customer}/>}
        </Tab.Pane>
        <Tab.Pane eventKey="default-notes">
            <CustomerNotes datainfo={customer}/>
        </Tab.Pane>       
        <Tab.Pane eventKey="default-rates">            
            <ProductRates RateData={customer.customerProductRates} MainCustomerID={customer.customerId} setRefreshData = {setRefreshData} RefreshData = {setRefreshData} />
        </Tab.Pane>        
        <Tab.Pane eventKey="default-docs">
            {/* <Clientdocuments clientID={customer.customerId} />             */}
            <DocumentManagement sID={customer.customerId} context={"client"} />    
        </Tab.Pane>
        <Tab.Pane eventKey="default-recurring-tasks">
            {/* <RecurringTasks data={customer.recurringTasks} /> */}
            {RecurringTabSelect && <RecurringTasks CustomerID={customer.customerId} />}
        </Tab.Pane>
        <Tab.Pane eventKey="default-emar">
            <Emar CustomerID={customer.customerId}/>
        </Tab.Pane>
        <Tab.Pane eventKey="default-schedule">
        {ScheduleTabSelect && <ClientSchedule CustomerID={customer.customerId}/>}
        </Tab.Pane>        
        <Tab.Pane eventKey="default-invoicing">
        {InvoiceTabSelect && <InvoiceList CustomerID={customer.customerId}/>}
        </Tab.Pane>        
        <Tab.Pane eventKey="default-incident">
        {IncidentTabSelect && <CustomerIncident CustomerID={customer.customerId}/>}
        </Tab.Pane>        
        <Tab.Pane eventKey="default-risk">
        {RiskTabSelect && <CustomerRiskAssessment CustomerID={customer.customerId} CustomerName={customer.firstName}/>}
        </Tab.Pane>        
        <Tab.Pane eventKey="default-previsits">
        {PrevisitsSelect && <CustomerPreviousVisits CustomerID={customer.customerId} /> }
        </Tab.Pane>        

    </Tab.Content>
</Tab.Container>

{/* Profile Image Upload */}
    <ProfileImageUploader 
        ShowProfileImageUploadPopup={ShowProfileImageUploadPopup} 
        setShowProfileImageUploadPopup={setShowProfileImageUploadPopup} 
        setUserProfile = {setUserProfile} 
        customerId={customer.customerId} 
    />

    </Layout>    
  ) 

}


export default Client